import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';
import type { FuelCardVehicle } from '@cobliteam/common-types';
import type { FuelCardAction } from './actions';
import { FuelCardActionTypes } from './fuelCardActionTypes';

export interface FuelCardState {
  transactionsReportWebData: WebData<void>;
  vehiclesWebData: WebData<FuelCardVehicle[]>;
  updateVehiclesWebData: WebData<void>;
}

export const fuelCardInitialState: FuelCardState = {
  transactionsReportWebData: webDataNotAsked(),
  vehiclesWebData: webDataNotAsked(),
  updateVehiclesWebData: webDataNotAsked(),
};

export const fuelCardReducer = (state = fuelCardInitialState, action: FuelCardAction): FuelCardState => {
  switch (action.type) {
    case FuelCardActionTypes.DOWNLOAD_TRANSACTIONS_REPORT_REQUEST:
      return { ...state, transactionsReportWebData: webDataFetching() };

    case FuelCardActionTypes.DOWNLOAD_TRANSACTIONS_REPORT_END:
      return { ...state, transactionsReportWebData: webDataNotAsked() };

    case FuelCardActionTypes.LOAD_FUEL_VEHICLES_REQUEST:
      return { ...state, vehiclesWebData: webDataFetching() };

    case FuelCardActionTypes.LOAD_FUEL_VEHICLES_SUCCEEDED:
      return { ...state, vehiclesWebData: webDataSuccess(action.payload) };

    case FuelCardActionTypes.LOAD_FUEL_VEHICLES_FAILED:
      return { ...state, vehiclesWebData: webDataError() };

    case FuelCardActionTypes.UPDATE_FUEL_VEHICLES_REQUEST:
      return { ...state, updateVehiclesWebData: webDataFetching() };

    case FuelCardActionTypes.UPDATE_FUEL_VEHICLES_END:
      return { ...state, updateVehiclesWebData: webDataNotAsked() };

    default:
      return state;
  }
};
